<template>
  <div class="container-fluid">
    <form v-on:submit.prevent>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label"> Advertiser Name <sup>*</sup></label>
        <div class="col-sm-5 pr-5">
          <multiselect
            name="advertiser"
            :options="DSPList"
            label="advertiser_name"
            v-model="profile.selected_profile"
            track-by="advertiser_id"
            class="form-control select_filter"
            id="advertiser"
            placeholder="Advertiser Name"
            autocomplete="off"
            style="height: 41px"
            @select="DSPChanged"
          />
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-primary"
            style="font-size: 12px"
            @click="addNewDSP()"
          >
            Create New
          </button>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label"> Advertiser Id <sup>*</sup> </label>
        <div class="col-sm-7 pr-5">
          <input
            type="number"
            name="advertiser_id"
            v-model="profile.selected_profile.advertiser_id"
            class="form-control"
            id="advertiser_id"
            placeholder="DSP Advertiser ID"
            autocomplete="off"
            style="height: 40px"
            v-on:input="checkProfileDuplicasy($event)"
            :disabled='(profile.selected_profile && profile.selected_profile.advertiser_id) ? true : false'
          />
          <p
								class="no-data-style"
                style="height:10px"
								
							>{{profile.duplicateProfile? 'DSP account with this id already exists.':''}}</p>
          
        </div>
      </div>
      <div class="form-group row" style="padding-left: 0px">
        <div class="col-sm-3 col-form-label">
          <label class="form-check-label" for="exampleCheck1">Active</label>
        </div>
        <div
          class="col-form-label"
          style="margin-left: 15px; margin-right: 30px"
        >
          <div
            class="form-check d-inline-block"
            style="display: flex !important"
          >
            <input
              type="checkbox"
              v-model="profile.active"
              :disabled="
                profile.active &&
                profile.disable_date != '' &&
                profile.disable_date != null
              "
              value="true"
              style="padding-bottom: 5px"
              class="form-check-input"
              id="exampleCheck1"
              autocomplete="off"
              @click="activeValueChange($event)"
            />
          </div>
        </div>
        <div
          class="col-sm-7 form-group"
          v-if="profile.showDate"
          style="padding: 0px"
        >
          <div class="form-group col" style="padding: 0px">
            <div class="form-group row" style="margin: 0px">
              <div
                class="col-form-label align-self-center"
                style="
                  padding-top: 0px;
                  margin: 0px;
                  padding: 0px;
                  margin-top: 0px;
                "
                :style="
                  ifDisabledOnPastDate(profile.disable_date)
                    ? 'margin-top:5px'
                    : 'margin-top:-4px'
                "
              >
                <label class="form-check-label" for="exampleCheck1">{{
                  ifDisabledOnPastDate(profile.disable_date)
                    ? "Disabled On " + getFormattedDate(profile.disable_date)
                    : "Disables On"
                }}</label>
              </div>
              <div class="col-sm-5" style="padding-top: 0px">
                <b-form-datepicker
                  :id="index + '_disable'"
                  name="disable_date"
                  placeholder="MM/DD/YYYY"
                  class="date_wrapper"
                  v-model="profile.disable_date"
                  menu-class="w-100"
                  size="sm"
                  :date-format-options="{
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  }"
                  calendar-width="180%"
                  :hide-header="true"
                  :today-button="false"
                  :min="min_date_disable"
                  locale="en"
                  v-if="!ifDisabledOnPastDate(profile.disable_date)"
                  @input="updateTheValidation(-1)"
                ></b-form-datepicker>
              </div>
              <div
                class="col-sm-3"
                style="margin: 0px; padding: 0px"
                v-if="
                  !ifDisabledOnPastDate(profile.disable_date) &&
                  profile.disable_date &&
                  profile.active
                "
              >
                <button
                  class="btn btn-primary"
                  style="font-size: 12px"
                  @click="deleteDate"
                >
                  Delete Date
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-sm-1"
          style="text-align: center"
          v-if="
            profile.showDate &&
            profile.disable_date &&
            !ifDisabledOnPastDate(profile.disable_date)
          "
        >
          <p style="font-size: 13px; color: orange">Pending InActive</p>
        </div>
      </div>

      <div
        class="row"
        style="padding-top: 10px"
        v-if="!ifDisabledOnPastDate(profile.disable_date) && profile.showDate"
      >
        <div class="msg-style">
          <p class="msg-text-style" style="">
            {{ "Update will happen at 11:59pm on selected date" }}
          </p>
        </div>
      </div>
      <div
        class="no-data-style row"
        style="padding-top: 10px; margin-left: 15px"
        v-if="index == noDateForActiveFalse && profile.showDate"
      >
        Provide Date to disable the profile
      </div>
    </form>
  </div>
</template>
<script>
import moment from "moment";

import datePicker from "vue-bootstrap-datetimepicker";
import Multiselect from "vue-multiselect";
export default {
  components: {
    datePicker,
    Multiselect
  },
  name: "DSPAccountData",
  props: [
    "DSPList",
    "brandsList",
    "isDisable",
    "profile",
    "index",
    "updateDisableDate",
    "client_id",
    "vendorList",
    "sellerList",
    "isAgency",
    "noDateForActiveFalse",
  ],
  computed: {
    min_date_disable() {
      //only allow future dates, will prevent past as well as current date from selection
      return moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      advertiser: { id: "", name: "" },
    };
  },
  methods: {
    moment,
    DSPChanged(e) {

      if (
        this.profile.type == "DSP Accounts"
      ) {
        if(Object.keys(this.profile.selected_profile).length){
            this.$emit('convertToUniqueDSPDataSet',
            this.profile.selected_profile.advertiser_id.trim(),
            "remove"
          );
        }
        
      }

      this.profile?(this.profile.duplicateProfile = false):''
      let obj = {
        date: e.disable_date,
        index: this.index,
        selected: e,
        active:e.active,
        isAgency:e.isAgency,
        prev_go_client_id:e.prev_go_client_id
      };
      this.$emit("DSPUpdated", obj);
    },
    activeValueChange(val) {
      if (!val.currentTarget.checked) {
        this.$emit("updateDisableDate", this.index, true);
      } else {
        this.$emit("updateDisableDate", this.index, false);
      }
    },
    agencyDDValueChange(val) {
      if (!val.currentTarget.checked) {
        this.$emit("toggleAdAgencyDD", this.index, true);
      } else {
        this.$emit("toggleAdAgencyDD", this.index, false);
      }
    },
    ifDisabledOnPastDate(disableDate) {
      let x = moment(disableDate).isSameOrBefore(moment());
      return x;
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    setDateFormat(date) {
      return moment().format("MM/DD/YYYY");
    },
    updateTheValidation(data) {
      this.$emit("dateProvideDisableVAlidation", data);
    },
    deleteDate() {
      this.$emit("removeDate", this.index);
    },
    addNewDSP(data, type) {
      let indx = this.index;
      this.$emit("openDSPPopUp", indx);
    },
    checkProfileDuplicasy(event) {
				let data = event.currentTarget.value;
				this.profile.duplicateProfile = false;
				let isPresent = this.DSPList.find(
					e =>
						e.advertiser_id &&
						e.advertiser_id.toLowerCase().trim() ==
							data.toLowerCase().trim() &&
						e.advertiser_name != this.profile.selected_profile.advertiser_name
				);

				if (isPresent) {
					this.profile.duplicateProfile = true;
				} else {
					this.profile.duplicateProfile = false;
				}
			}
  },
};
</script>